// extracted by mini-css-extract-plugin
export var buttonsWrapper = "SocialVideo-module--buttonsWrapper--b6d51";
export var controlButton = "SocialVideo-module--controlButton--32c3a";
export var playButton = "SocialVideo-module--playButton--e7b3c";
export var pulse = "SocialVideo-module--pulse--303d6";
export var videoWrapper = "SocialVideo-module--videoWrapper--6fd5f";
export var wrapper = "SocialVideo-module--wrapper--780d3";